var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticStyle: { "margin-right": "10px" },
      attrs: { effect: "dark", content: _vm.tip, placement: "top" },
    },
    [
      _c("el-button", {
        attrs: {
          circle: "",
          type: "primary",
          icon: "el-icon-upload2",
          size: "small",
        },
        on: { click: _vm.click },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }